import type { EvergladesProductsApiSuccess } from '@shared/types/types.ts';
import { composeFallbackTileListPage } from '@tilelist/domain/composition/TileListFallbackCompositionStrategy.ts';
import type { PageLoadContext, PageLoadStrategy } from './PageLoadStrategy.ts';

/**
 *
 *
 *
 */
export class FallbackTileListStrategy implements PageLoadStrategy {
    intents(_ctx: PageLoadContext) {
        return ['similar'] as const;
    }

    async compose(response: EvergladesProductsApiSuccess, _ctx: PageLoadContext) {
        return composeFallbackTileListPage(response);
    }
}
